'use client'

import { useFeatureToggle } from '@/components/utils/FeatureToggleContext'
import { Permission } from '@/lib/permissions'
import { usePermissionValidation } from '@/components/layout/dashboard/hooks/usePermission'
import AceLogoBeta from '@/resources/images/ace-logo-beta.svg'
import AceLogo from '@/resources/images/ace-logo.png'
import AceLogoNonprod from '@/resources/images/ace-logo-nonprod.svg'
import AceLogoReadonly from '@/resources/images/ace-logo-readonly.svg'
import AceLogoTraining from '@/resources/images/ace-logo-training.svg'
import Image from 'next/image'

export function GlobalPageHeaderLogo() {
  const isBeta = useFeatureToggle('FT_BETA')
  const isNonprod = useFeatureToggle('FT_NONPROD')
  const isTraining = useFeatureToggle('FT_TRAINING')
  const hasRestrictedView = usePermissionValidation(Permission.VIEW_RESTRICTED)
  if (isTraining) {
    return (
      <Image src={AceLogoTraining} alt="Training ACE Logo" className="object-scale-down p-1" fill />
    )
  }

  if (isBeta) {
    return <Image src={AceLogoBeta} alt="Beta ACE Logo" className="object-scale-down p-1" fill />
  }

  if (isNonprod) {
    return (
      <Image src={AceLogoNonprod} alt="Nonprod ACE Logo" className="object-scale-down p-1" fill />
    )
  }

  if (hasRestrictedView) {
    return (
      <Image src={AceLogoReadonly} alt="Readonly ACE Logo" className="object-scale-down p-1" fill />
    )
  }

  return <Image src={AceLogo} alt="ACE Logo" className="object-contain" fill />
}
